import { render, staticRenderFns } from "./Tip7.vue?vue&type=template&id=22613398&scoped=true&lang=pug"
import script from "./Tip7.vue?vue&type=script&lang=ts"
export * from "./Tip7.vue?vue&type=script&lang=ts"
import style0 from "./Tip7.vue?vue&type=style&index=0&id=22613398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22613398",
  null
  
)

export default component.exports